import http from '../../utils/Http/Http'

type CampaignParams = {
	campaignId: string
	campaignName?: string
	firstSentence?: string
	openingHook?: string | null
	customOpeningHook?: string | null
	agentName?: string
	followUpCallerName?: string
	adviceForAi?: string
	companyName?: string
	testPhoneNumber?: string
	campaignType?: string
	agentId?: string
	batches?: {
		front_uploaded?: number
		uploaded?: number
	}
}

export const updateCampaign = ({
	campaignId,
	campaignName,
	firstSentence,
	openingHook,
	customOpeningHook,
	agentName,
	followUpCallerName,
	adviceForAi,
	companyName,
	testPhoneNumber,
	campaignType,
	agentId,
	batches,
}: CampaignParams) => {
	const url = `/campaigns/${campaignId}`
	const data = { campaign_id: campaignId } as any
	if (campaignName) {
		data.campaign_name = campaignName
	}

	if (firstSentence !== undefined) {
		data.first_sentence = firstSentence
	}

	if (openingHook !== undefined) {
		data.opening_hook = openingHook
	}

	if (customOpeningHook !== undefined) {
		data.custom_opening_hook = customOpeningHook
	}

	if (agentName !== undefined) {
		data.agent_name = agentName
	}

	if (followUpCallerName !== undefined) {
		data.follow_up_caller_name = followUpCallerName
	}

	if (adviceForAi !== undefined) {
		data.prompt_injection = adviceForAi
	}

	if (companyName !== undefined) {
		data.company_name = companyName
	}

	if (testPhoneNumber !== undefined) {
		data.test_phone_number = testPhoneNumber
	}

	if (campaignType !== undefined) {
		data.campaign_type = campaignType
	}

	data.agent_id = agentId
	data.batches = batches

	return http({
		data,
		url,
		method: 'put',
	})
}
